<template>
  <div class="py-2">
    <p class="text-gray-900 text-lg">
      <b>About me</b>
    </p>
    <p class="text-md md:text-lg text-gray-600 leading-normal">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur fuga veritatis molestiae quisquam. Fuga, officiis voluptas nostrum alias magni omnis. Voluptatum voluptatibus impedit ducimus consectetur tempore pariatur doloribus inventore quisquam!
    </p>
  </div>
</template>